import Page from "@/components/utilities/Page"
import { cn } from "@/lib/utils"
import { useRef } from "react"
import useStuck from "@/hooks/useStuck"
import { ProgressBarTop } from "@/components/feedback/ProgressBarLoader"

export interface PageLayoutProps {
  title: string
  description?: string
  className?: string
  children: React.ReactNode
  style?: React.CSSProperties
  layout?: "center" | "fluid" | "center-big"
  loading?: boolean
  extra?: React.ReactNode
  showError?: boolean
  // after?: React.ReactNode
}

function PageLayout(props: PageLayoutProps) {
  const headerRef = useRef<HTMLDivElement | null>(null)
  const scrollContainerRef = useRef<HTMLDivElement | null>(null)
  const { dummy } = useStuck({ stuckElement: headerRef?.current, enabled: true, scrollContainer: scrollContainerRef?.current })
  const loose = props.layout === "center" || props.layout === "center-big"
  const looseBig = props.layout === "center-big"

  return (
    <Page title={props.title}>
      {/* <div className={"bg-backgroundrelative size-full overflow-auto"} style={props.style} ref={scrollContainerRef}> */}
      <div className={"bg-background relative size-full"} style={props.style} ref={scrollContainerRef}>
        <div className={cn(loose && "max-w-7xl mx-auto w-full")}>
          {dummy}
          {/* <LoadingBarTop loading={props.loading} /> */}
          {props.loading && <ProgressBarTop className={cn(!loose && "top-[60px]")} size={loose ? "lg" : "md"} />}
          <header
            className={cn(
              // "bg-background sticky top-14 z-10 flex items-center justify-between",
              "bg-background top-14 z-10 flex items-center justify-between",
              loose ? "px-4 pt-8 pb-2" : `border-border h-[60px] border-b px-8`,
              looseBig && "pt-16",
            )}
            ref={headerRef}
          >
            <div className="flex flex-col gap-1">
              <h1 className={cn(loose ? "text-[22px] font-bold" : "!text-xl", looseBig && "!text-3xl")}>{props.title}</h1>
              <span className="text-[17px]">{props.description}</span>
            </div>
            {props.extra}
          </header>
          <div className={cn(loose ? "px-4 pb-20" : "p-4 pb-20", looseBig && "pt-8")}>
            {/* <PageTransition>{props.children}</PageTransition> */}
            {props.children}
          </div>
        </div>
      </div>
    </Page>
  )
}

export default PageLayout
